import BidLabel from '../../../../elements/BidLabel/BidLabel'

const Quantity = ({ quantity }: { quantity: number }) => {
  return (
    <BidLabel
      value={`QTY ${quantity}`}
      theme={quantity > 1 ? 'red' : 'blue-dark'}
      fontStyles="text-12 md:text-10"
      twcss="px-6 md:py-2 h-auto"
      labelStyle="hollow"
    />
  )
}

export default Quantity
